import { render, staticRenderFns } from "./PricelistItemList.vue?vue&type=template&id=4c2e2a1c&"
import script from "./PricelistItemList.vue?vue&type=script&lang=js&"
export * from "./PricelistItemList.vue?vue&type=script&lang=js&"
import style0 from "./PricelistItemList.vue?vue&type=style&index=0&id=4c2e2a1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports